import { CityState, DataSource, HorizontalSpacer, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPayHistory extends Layout {
    citystateC: CityState;
    citystatePayee: CityState;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    labelAddress1: Label;
    labelAddress2: Label;
    labelAddress: Label;
    labelAdvanceInfo: Label;
    labelAdvanceTotal: Label;
    labelCellPhone: Label;
    labelDriverlabel: Label;
    labelFirstName: Label;
    labelName: Label;
    labelPayRollInfo: Label;
    labelPayeeMobilePhone: Label;
    labelPayeeName: Label;
    labelPayeePhone: Label;
    labelPayeeTitle: Label;
    labelPendingDeductions: Label;
    labelPendingDeductionsTotal: Label;
    labelPhone: Label;
    panelAdvance: Panel;
    panelDriver: Panel;
    panelName: Panel;
    panelOverview: Panel;
    panelPayee: Panel;
    panelPayroll: Panel;
    panelPendingDeductions: Panel;
    panelSpacer: Panel;
    sourceAdvanceInfo: DataSource;
    sourceAllPayees: DataSource;
    sourceDriverInfo: DataSource;
    sourceDrsPayrollHist: DataSource;
    sourceDrsPendingDeduct: DataSource;
    tableAdvanceInfo: Table;
    tablePendingDeductions: Table;
    textboxCheckNo1: Textbox;
    textboxCheckNo2: Textbox;
    textboxDate1: Textbox;
    textboxDate2: Textbox;
    textboxGross1: Textbox;
    textboxGross2: Textbox;
}
